import { environment } from '@core/environments/environments';

export const AUTH_API_ROUTES = {
  login: `${environment.baseUrl}/auth/login`,
  register: `${environment.baseUrl}/auth/register`,
  requestPasswordReset: `${environment.baseUrl}/auth/request-set-password`,
  setNewPassword: `${environment.baseUrl}/auth/set-password`,
};
